<!-- 组件说明 -->
<template>
  <div class="container">
    <div class="title"><i></i><span>同类商品推荐</span></div>
    <div class="rec-box">
      <div class="rec-item" v-for="(item, index) in commendList" :key="index">
        <div class="item-img c-pointer" @click="toDetail(item.id)">
          <img v-lazy="item.image" alt="" />
        </div>
        <a class="c-pointer" @click="toDetail(item.id)"> {{ item.name }}</a>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
//import x from ''
export default {
  props: ["gooodsDetail", "goodsType"],
  components: {},
  data() {
    return {
      commendList: [],
    };
  },
  computed: {},
  watch: {
    gooodsDetail: {
      handler: function (t, f) {
        if (this.goodsType == 1) {
          let categoryIds = t.categoryId;
          this.getCommendList({ categoryIds });
        } else {
          let categoryIds = this.getCombinationRecommend(
            t.goodsCombinationItemResults
          ).join();
          this.getCommendList({ categoryIds });
        }
      },
      immediate: true,
    },
  },
  methods: {
    getCommendList({ categoryId, categoryIds }) {
      this.$api
        .GET_GOODSLIST({
          categoryId: categoryId || "",
          categoryIds: categoryIds || "",
          pageNumber: 1,
          pageSize: 3,
        })
        .then((res) => {
          if (res.status) {
            //console.log(res.data);
            this.commendList = res.data.pageable.data;
          }
        });
    },
    getCombinationRecommend(data) {
      let arr = [];
      data.map((item) => {
        arr.push(item.categoryId);
      });

      //console.log(arr)
      return arr;
    },
    toDetail(id) {
      // const {origin} = window.location;
      // const page = '/main/detail';
      // let path= origin + page + '?goodsId=' + id + '&type=1';
      // window.location.href = path;
      // console.log(path)

      this.$router.push({ name: "detail", query: { goodsId: id, type: 1 } });
    },
  },
  mounted() {},
  // created(){
  //   if(this.goodsType==1){
  //     this.getCommendList()
  //   }else{
  //     this.getCommendList(this.getCombinationRecommend(this.gooodsDetail.goodsCombinationItemResults).join())
  //   }
  // }
};
</script>

<style lang='scss' scoped>
.container {
  height: 680px;
  overflow: hidden;
  margin-left: 28px;
  width: 100%;
  border-left: 1px solid #f5f5f5;
  .title {
    margin: 0 0 20px 28px;
    i {
      display: inline-block;
      height: 12px;
      width: 3px;
      background-color: #fa4b4b;
      margin-right: 8px;
    }
    span {
      font-size: 14px;
      color: #505050;
    }
  }
}
.rec-box {
  .rec-item {
    @include flex-d-c;
    align-items: center;

    .item-img {
      width: 150px;
      height: 150px;

      img {
        @include size(100%, 100%);
      }
    }
    a {
      text-align: center;
      margin: 16px 35px 10px;
      line-height: 20px;
      @include textLineClamp(2);
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/main/detail/components/goods-recommend.vue